import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface ScanFailedModalProps {
  open: boolean;
  onTryAgain: () => void;
  errorMessage?: string;
}

export const ScanFailedModal: React.FC<ScanFailedModalProps> = ({
  open,
  onTryAgain,
  errorMessage,
}) => {
  return (
    <Dialog open={open}>
      <DialogContent className="sm:max-w-[800px] bg-white rounded-lg px-20 py-10">
        <div className="flex flex-col items-center justify-center space-y-6">
          <h2 className="text-2xl font-bold text-center">Scan Failed</h2>
          <p className="text-gray-600 text-center text-sm">
            {errorMessage || "The page doesn't appear to contain a case study. Please check the URL and try again."}
          </p>

          {/* Illustration */}
          <div className="py-8">
            <img
              src="/scan_failed.svg"
              alt="Scan failed illustration"
              width={150}
              height={150}
              className="object-contain"
            />
          </div>

          <Button
            onClick={onTryAgain}
            className="bg-black hover:bg-gray-800 text-white px-8"
          >
            Try Again
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
